import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class EcoScoreService {
  /**
   * @param carbonIntensity is the impact per traveler, per day
   * @returns a number from 1 to 10. 1 beeing the highest impact and 10 beeing the lowest
   */
  getEcoScore(carbonIntensity: number): number {
    switch (true) {
      case carbonIntensity > 400:
        return 1; // >400 kg CO2e
      case carbonIntensity > 300:
        return 2; // >300 kg CO2e
      case carbonIntensity > 200:
        return 3; // >200 kg CO2e
      case carbonIntensity > 150:
        return 4; // >150 kg CO2e
      case carbonIntensity > 100:
        return 5; // >100 kg CO2e
      case carbonIntensity > 45:
        return 6; // >45 kg CO2e
      case carbonIntensity > 30:
        return 7; // >30 kg CO2e
      case carbonIntensity > 20:
        return 8; // >20 kg CO2e
      case carbonIntensity > 10:
        return 9; // >10 kg CO2e
      default:
        return 10; // ≤10 kg CO2e
    }
  }

  /**
   * @param ecoScore number from 1 to 10. can be calculated from the getEcoScore method of this service
   * @returns css variable with the color associated to the eco score
   */
  getColor(ecoScore?: number) {
    if (!ecoScore || ecoScore < 1 || ecoScore > 10)
      return 'var(--color-greyscale-400)';
    // Gradient from red (bad) through yellow (medium) to green (good)
    const rootStyle = getComputedStyle(document.documentElement);
    const color = [
      // 'var(--color-error-300)', // 1 - worst
      // 'var(--color-error-300)', // 2
      // 'var(--color-warning-300)', // 3
      // 'var(--color-warning-300)', // 4
      // 'var(--color-warning-300)', // 5
      // 'var(--color-warning-300)', // 6
      // 'var(--color-validation-300)', // 7
      // 'var(--color-validation-300)', // 8
      // 'var(--color-validation-300)', // 9
      // 'var(--color-validation-300)', // 10 - best

      rootStyle.getPropertyValue('--color-dark-red').trim(), // 1 - pire
      rootStyle.getPropertyValue('--color-bright-red').trim(), // 2
      rootStyle.getPropertyValue('--color-dark-orange').trim(), // 3
      rootStyle.getPropertyValue('--color-bright-orange').trim(), // 4
      rootStyle.getPropertyValue('--color-yellow').trim(), // 5
      rootStyle.getPropertyValue('--color-yellow-green').trim(), // 6
      rootStyle.getPropertyValue('--color-primary-100').trim(), // 7
      rootStyle.getPropertyValue('--color-teal').trim(), // 8
      rootStyle.getPropertyValue('--color-bright-green').trim(), // 9
      rootStyle.getPropertyValue('--color-dark-green').trim(), // 10 - meilleur
    ];
    return color[ecoScore - 1];
  }
}
